// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"548b99e8","453":"4ab4699a"}[chunkId] + ".chunk.js";
};